export default "__VITE_ASSET__BXINosIb__"